$(document).ready(function () {
    let additionalScrollBar = () => {
        let tableContainers = $(".js-table-additional-scroll");

        tableContainers.each(function (index, container) {
            let tableContainer = $(container);
            let table = tableContainer.find('table');
            let additionalScrollContainer = tableContainer.prev();
            let additionalScrollDiv = additionalScrollContainer.find('div');
            additionalScrollDiv.width(table.width()+220);

            additionalScrollContainer.scroll(function () {
                tableContainer.scrollLeft(additionalScrollContainer.scrollLeft());
            });
            tableContainer.scroll(function () {
                additionalScrollContainer.scrollLeft(tableContainer.scrollLeft());
            });
        });

    }

    additionalScrollBar();
});
